import { z } from "zod";
import { TObjectBase } from "../../base";

export const TBim2ShareIntegrationSettings = z.object({
  companyAssetID: z.number().optional(),
});
export type IBim2ShareIntegrationSettings = z.infer<
  typeof TBim2ShareIntegrationSettings
>;

export const TApiBimModel = z.object({
  name: z.string(),
  id: z.string(),
  assetID: z.string(),
  bimFileID: z.string(),
});
export type IApiBimModel = z.infer<typeof TApiBimModel>;

export const TApiBimAsset = z.object({
  name: z.string(),
  id: z.string(),
  parentId: z.string().nullable(),
});
export type IApiBimAsset = z.infer<typeof TApiBimAsset>;

export const TApiBimFloor = z.object({
  name: z.string(),
  id: z.string(),
});
export type IApiBimFloor = z.infer<typeof TApiBimFloor>;

// BIM2SHARE API

export const TBim2ShareLoginResponse = z.string();
export type IBim2ShareLoginResponse = z.infer<typeof TBim2ShareLoginResponse>;

export const TBim2ShareAsset = z.object({
  Id: z.number(),
  ProjectNo: z.string(),
  Name: z.string(),
  ParentId: z.number().nullable(),
  ParentName: z.string().nullable(),
  Level: z.number(),
});
export type IBim2ShareAsset = z.infer<typeof TBim2ShareAsset>;

export const TBim2ShareAssetResponse = z.array(TBim2ShareAsset);
export type IBim2ShareAssetResponse = z.infer<typeof TBim2ShareAssetResponse>;

export const TBim2ShareFile = z.object({
  FileId: z.number(),
  BimFileId: z.number(),
  ProjectId: z.number(),
  FileName: z.string(),
  Floor: z.string().nullable(),
});
export type IBim2ShareFile = z.infer<typeof TBim2ShareFile>;

export const TBim2ShareFilesResponse = z.array(TBim2ShareFile);
export type IBim2ShareFilesResponse = z.infer<typeof TBim2ShareFilesResponse>;

export const TBim2ShareFloor = z.object({
  Guid: z.string().nullable(),
  Name: z.string(),
  FileId: z.number(),
  BimFileId: z.number(),
});
export type IBim2ShareFloor = z.infer<typeof TBim2ShareFloor>;

export const TBim2ShareObjectFloor = z.object({
  Name: z.string(),
  GUID: z.string(),
});
export type IBim2ShareObjectFloor = z.infer<typeof TBim2ShareObjectFloor>;

export const TBim2ShareFloorsResponse = z.array(TBim2ShareFloor);
export type IBim2ShareFloorsResponse = z.infer<typeof TBim2ShareFloorsResponse>;

export const TRawTaskBimFiles = z
  .object({
    bimFileID: z.string(),
    propertyID: z.string(),
  })
  .extend(TObjectBase.shape);
export type IRawTaskBimFiles = z.infer<typeof TRawTaskBimFiles>;

export const TBim2ShareObjectResponse = z.object({
  Header: z.array(z.string()),
  Rows: z.array(z.array(z.any())),
});
export type IBim2ShareObjectResponse = z.infer<typeof TBim2ShareObjectResponse>;
